import { lazy } from 'react'

const UpgradeLanding = lazy(() => import('./UpgradeLanding'))

export default {
  path: '/upgrade-plan',
  Component: UpgradeLanding,
  access: 'PUBLIC',
}
